import { store } from "api-store/store";  // Adjust the path to your store
import {API } from "utility/constants";
import { ENVMAPPING } from "utility/helper";
import { reauthenticateOnForbidden } from "./handleAuthError";

export interface RequestOptions {
  method?: string;
  headers?: { [key: string]: string };
  body?: any;
}

const defaultHeaders = {
  'Content-Type': 'application/json',
  'Content-Security-Policy': `default-src 'self'; script-src 'self' ${ENVMAPPING(window.location.origin).origin}; style-src 'self' ${ENVMAPPING(window.location.origin).origin};`,
  'X-Frame-Options': 'DENY',
  'X-Content-Type-Options': 'nosniff',
  'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate',
};


export async function fetchService<T>(
  url: string,
  options: RequestOptions = {}
): Promise<T> {
  const { method = 'GET', headers = {}, body = null } = options;

  const doFetch = (token: string | null): Promise<Response> => {
    // Add Authorization header if token is provided
    const authHeaders: { [key: string]: string } = token ? { 'Authorization': `Bearer ${token}` } : {};
    // Combine headers and ensure it matches the HeadersInit type
    const combinedHeaders: HeadersInit = { ...defaultHeaders, ...headers, ...authHeaders };
    return fetch(API + url, {
      method,
      headers: combinedHeaders,
      body: body ? JSON.stringify(body) : null,
      mode: 'cors',
      // credentials: 'include',
    });
  };

  // Retrieve the token from the Redux store
  let response = await doFetch(store.getState().userData.access_token);

  // API Gateway returns 403 when the Azure AD token is stale/expired. Try a
  // silent forced refresh and, if it succeeds, retry the request once.
  if (response.status === 403) {
    const refreshedToken = await reauthenticateOnForbidden();
    if (refreshedToken) {
      response = await doFetch(refreshedToken);
    }
  }

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json() as Promise<T>;
}